import React from 'react';
import PlansSection from '../../../sections/AdminDashboard/Configuration/Plans';

const Plans = () => {
  return <PlansSection />;
};

export default Plans;
